export enum DrawerContentType {
  None,
  AddPermission,
  CreateNotification,
}
